import { baseApi } from "./baseApi";

export const roleApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // get all roles
        getAllRoles: builder.query<any, void>({
            query: () => ({
                url: `/role`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // create a new role
        createRole: builder.mutation<any, Record<string, any>>({
            query: (data) => ({
                url: `/role`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["roles"],
        }),

        // fetch roles for dropdown
        getRolesDropdown: builder.query<any, void>({
            query: () => ({
                url: `/role/dropdown`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // get permission categories
        getPermissionCategories: builder.query<any, void>({
            query: () => ({
                url: `/role/permission-categories`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // get all permissions
        getAllPermissions: builder.query<any, { page?: number; limit?: number }>({
            query: ({ page = 1, limit = 10 } = {}) => ({
                url: `/role/permissions?page=${page}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // get role by ID
        getRoleById: builder.query<any, string>({
            query: (roleId) => ({
                url: `/role/${roleId}`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // get all permissions assigned to a specific role
        getPermissionsByRole: builder.query<any, string>({
            query: (roleId) => ({
                url: `/role/${roleId}/permissions`,
                method: "GET",
            }),
            providesTags: ["roles"],
        }),

        // update role by ID
        updateRoleById: builder.mutation<any, { roleId: string; data: Record<string, any> }>({
            query: ({ roleId, data }) => ({
                url: `/role/${roleId}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["roles"],
        }),

        // delete role by ID
        deleteRoleById: builder.mutation<any, string>({
            query: (roleId) => ({
                url: `/role/${roleId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["roles"],
        }),

        // change employee password
        updateEmployeePassword: builder.mutation<
            any,
            { old_password: string; new_password: string; new_password_confirmation: string }
        >({
            query: (data) => ({
                url: `/employees/changePassword`,
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const {
    useGetAllRolesQuery,
    useCreateRoleMutation,
    useGetRolesDropdownQuery,
    useGetPermissionCategoriesQuery,
    useGetAllPermissionsQuery,
    useGetRoleByIdQuery,
    useGetPermissionsByRoleQuery, 
    useUpdateRoleByIdMutation,
    useDeleteRoleByIdMutation,
    useUpdateEmployeePasswordMutation,
    



} = roleApi;
